import { GoogleOAuthProvider } from '@react-oauth/google';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { theme } from './muiTheme';
import { Router } from './pages/Router';

function App() {
	const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
	const app = (
		<ThemeProvider theme={theme}>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<CssBaseline />
				<Router />
			</LocalizationProvider>
		</ThemeProvider>
	);

	if (!googleClientId) return app;

	return (
		<GoogleOAuthProvider clientId={googleClientId}>
			{app}
		</GoogleOAuthProvider>
	);
}

export default App;
